import routePaths from 'constants/route-paths';

export interface BaseDataSubmenu {
  label: string;
  id: BaseDataForm | string;
  path: string;
}

export enum BaseDataForm {
  GENERAL = 'GENERAL',
  CONTRACT = 'CONTRACT',
  SYSTEM_ACCESS = 'SYSTEM_ACCESS',
  CHECKLIST = 'CHECKLIST',
  ADVICE_CONSULTATION = 'ADVICE_CONSULTATION',
  PASTORAL_CARE = 'PASTORAL_CARE',
  UTENSILS = 'UTENSILS',
  CONTACTS = 'CONTACTS',
  INVOICING = 'INVOICING',
  DOCUMENT_MANAGEMENT = 'DOCUMENT_MANAGEMENT',
}

export const employeeSubmenu: BaseDataSubmenu[] = [
  { label: 'baseData_submenu_general', id: BaseDataForm.GENERAL, path: routePaths.DATA_GENERAL },
  { label: 'baseData_submenu_contract', id: BaseDataForm.CONTRACT, path: routePaths.DATA_CONTRACT },
  {
    label: 'baseData_submenu_systemAccess',
    id: BaseDataForm.SYSTEM_ACCESS,
    path: routePaths.DATA_ACCESS,
  },
];

export const residentSubmenu: BaseDataSubmenu[] = [
  { label: 'baseData_submenu_general', id: BaseDataForm.GENERAL, path: routePaths.DATA_GENERAL },
  { label: 'baseData_submenu_contract', id: BaseDataForm.CONTRACT, path: routePaths.DATA_CONTRACT },
  {
    label: 'baseData_submenu_invoicing',
    id: BaseDataForm.INVOICING,
    path: routePaths.DATA_INVOICING,
  },
  {
    label: 'baseData_submenu_checklist',
    id: BaseDataForm.CHECKLIST,
    path: routePaths.DATA_CHECKLIST,
  },
  {
    label: 'baseData_submenu_adviceConsultation',
    id: BaseDataForm.ADVICE_CONSULTATION,
    path: routePaths.DATA_ADVICE_CONSULTATION,
  },
  {
    label: 'baseData_submenu_pastoralCare',
    id: BaseDataForm.PASTORAL_CARE,
    path: routePaths.DATA_PASTORAL_CARE,
  },
  { label: 'baseData_submenu_utensils', id: BaseDataForm.UTENSILS, path: routePaths.DATA_UTENSILS },
  { label: 'baseData_submenu_contacts', id: BaseDataForm.CONTACTS, path: routePaths.DATA_CONTACTS },
  {
    label: 'baseData_submenu_documentManagement',
    id: BaseDataForm.DOCUMENT_MANAGEMENT,
    path: routePaths.DATA_DOCUMENT_MANAGEMENT,
  },
];
